import { createOOIStoreFrontBILogger } from '@wix/wixstores-client-core';
import { removeUndefinedKeys } from '../../lib/removeUndefinedKeys';
import { clickOnAddToCartSf } from '@wix/bi-logger-ec-sf/v2';
export function createOnlineStoresBiLogger(wixAPI, platformServices) {
    var user = wixAPI.window.viewMode === 'Site'
        ? { visitor_id: platformServices.bi.visitorId }
        : { uuid: platformServices.bi.ownerId };
    return createOOIStoreFrontBILogger(user, platformServices.bi.biToken, {
        isMerchant: false,
        appName: 'Stores',
        _msid: platformServices.bi.metaSiteId,
    }, platformServices.biLoggerFactory());
}
export function reportAddToCartBI(context, _a) {
    var _b;
    var origin = _a.origin, productId = _a.productId, hasOptions = _a.hasOptions, quantity = _a.quantity, trackData = _a.trackData;
    void context.biLogger.report(clickOnAddToCartSf(removeUndefinedKeys({
        productId: productId,
        quantity: quantity,
        hasOptions: hasOptions,
        origin: origin,
        buttonType: trackData === null || trackData === void 0 ? void 0 : trackData.buttonType,
        appName: trackData === null || trackData === void 0 ? void 0 : trackData.appName,
        isNavigateCart: trackData === null || trackData === void 0 ? void 0 : trackData.isNavigateCart,
        navigationClick: trackData === null || trackData === void 0 ? void 0 : trackData.navigationClick,
        productType: trackData === null || trackData === void 0 ? void 0 : trackData.productType,
        impressionId: trackData === null || trackData === void 0 ? void 0 : trackData.impressionId,
        galleryProductsLogic: trackData === null || trackData === void 0 ? void 0 : trackData.galleryProductsLogic,
        rank: trackData === null || trackData === void 0 ? void 0 : trackData.rank,
        galleryInputId: trackData === null || trackData === void 0 ? void 0 : trackData.galleryInputId,
        Is_sticky_button: (_b = trackData === null || trackData === void 0 ? void 0 : trackData.Is_sticky_button) !== null && _b !== void 0 ? _b : false,
    })));
}
//# sourceMappingURL=bi.utils.js.map